import clsx from "clsx";
import * as React from "react";
import { Label } from "@/components/ui/label";
import Icon, { ICON_SIZES } from "./Icon";
import Tooltip from "./Tooltip";

export type InputLabelProps = {
  withSpacing?: boolean;
  tooltipText?: React.ReactNode;
  value?: React.ReactNode;
} & React.ComponentPropsWithoutRef<typeof Label>;

const InputLabel: React.FC<InputLabelProps> = ({
  withSpacing = true,
  tooltipText,
  value,
  children,
  ...props
}) => {
  const content = children ?? value;

  if (tooltipText) {
    return (
      <Tooltip content={tooltipText} className="z-50">
        <Label className={clsx("inline-block", { ["mb-[6px]"]: withSpacing })} {...props}>
          {content}
        </Label>
        <Icon icon="circle-question" className="ml-2" size={ICON_SIZES.SM} />
      </Tooltip>
    );
  }

  return (
    <Label className={clsx("block", { ["mb-3"]: withSpacing })} {...props}>
      {content}
    </Label>
  );
};

export default InputLabel;
